import React from 'react';
import Header from '../components/header'; 
import Footer from '../components/footer'; 
import FloatingSocial from '../components/floating_social'; 

const Terms = () => {
  return (
    <div>
      <Header />
      
<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/9.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Terms & Conditions</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	 
	<div>
	<div className="container">

	<div className="card terms-card p-4">

	<p>
	Welcome to <strong>Hotel Pahadi Convention</strong>. By accessing our website, making a reservation,
	or using our services, you agree to comply with and be bound by the following
	Terms and Conditions. Please read them carefully.
	</p>

	<hr/>

	<h6>1. Reservations and Booking</h6>
	<ul>
	<li>All reservations are subject to availability and confirmation by Hotel Pahadi Convention.</li>
	<li>Guests must provide accurate personal and contact information while booking.</li>
	<li>The hotel reserves the right to cancel or refuse any reservation if incorrect or misleading information is provided.</li>
	</ul>

	<hr/>

	<h6>2. Check-in and Check-out</h6>
	<ul>
	<li><strong>Check-in Time:</strong> 12:00 PM</li>
	<li><strong>Check-out Time:</strong> 11:00 AM</li>
	<li>Early check-in and late check-out are subject to availability and may incur additional charges.</li>
	<li>Guests must present a valid government-issued photo ID at the time of check-in.</li>
	</ul>

	<hr/>

	<h6>3. Payment Policy</h6>
	<ul>
	<li>Guests may be required to pay an advance or full payment at the time of booking depending on the reservation type.</li>
	<li>The hotel accepts payments through approved methods including cash, credit/debit cards, or online payment gateways.</li>
	<li>All rates are subject to applicable taxes as per government regulations.</li>
	</ul>

	<hr/>

	<h6>4. Cancellation and Refund Policy</h6>
	<ul>
	<li>Cancellation policies may vary depending on the room type or booking platform.</li>
	<li>Cancellations made within the allowed period will be eligible for a refund or credit as per hotel policy.</li>
	<li>Late cancellations or no-shows may result in partial or full booking charges.</li>
	</ul>

	<hr/>

	<h6>5. Guest Responsibilities</h6>
	<ul>
	<li>Guests are expected to maintain proper conduct and respect hotel property, staff, and other guests.</li>
	<li>Any damage to hotel property caused by the guest will be charged accordingly.</li>
	<li>Illegal activities, misuse of hotel facilities, or disruptive behavior may result in immediate eviction without refund.</li>
	</ul>

	<hr/>

	<h6>6. Safety and Security</h6>
	<ul>
	<li>Guests are responsible for safeguarding their personal belongings.</li>
	<li>The hotel is not responsible for loss, theft, or damage to personal items unless deposited in the designated safe facility.</li>
	</ul>

	<hr/>

	<h6>7. Use of Facilities</h6>
	<ul>
	<li>Hotel amenities including restaurant, banquet halls, parking, and other facilities must be used according to hotel guidelines.</li>
	<li>The hotel reserves the right to restrict or modify access to facilities for maintenance or operational reasons.</li>
	</ul>

	<hr/>

	<h6>8. Privacy Policy</h6>
	<ul>
	<li>Any personal information provided during booking or stay will be handled in accordance with our privacy policy.</li>
	<li>Guest information will not be shared with third parties except where required by law.</li>
	</ul>

	<hr/>

	<h6>9. Website Content</h6>
	<p>
	All content on the Hotel Pahadi Convention website, including text, images, and logos,
	is the property of the hotel and may not be reproduced without permission.
	</p>

	<hr/>

	<h6>10. Changes to Terms</h6>
	<p>
	Hotel Pahadi Convention reserves the right to modify or update these
	Terms and Conditions at any time without prior notice.
	</p>

	<hr/>

	<h6>11. Governing Law</h6>
	<p>
	These Terms and Conditions are governed by the laws of India,
	and any disputes shall fall under the jurisdiction of courts in
	<strong>Rourkela, Odisha</strong>.
	</p>

	<hr/>

	<h6>12. Contact Information</h6>
	<p> <strong>Hotel Pahadi Convention</strong><br></br>
	Hotel Pahadi, Vedvyas, Rourkela, Odisha, India<br></br>
	Email: info@hotelpahadi.com<br></br>
	Phone: +91 9238394006, +91 9692908506 </p>
 
	<br />
	</div>
	</div>
        <Footer />
		<FloatingSocial />
   
	</div>
	</div>
  )
}

export default Terms;